import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import {
  Form as BaseForm,
  TextField,
  SelectFieldV2,
  SubmitButton,
  CancelPopupButton,
} from "ui/FormElement";

import { useContext } from "../Context";
import { useCountryContext } from "contexts/CountryContext";

export default function CreateForm({ closeForm }) {
  let FormSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .required("Email is required")
      .email("Provide Correct Email address"),
  });

  let [loader, setLoader] = useState(false);

  const { dispatch, state, actions } = useContext();
  const {
    dispatch: countryDispatch,
    state: countryState,
    actions: countryActions,
  } = useCountryContext();

  const [formData, setFormData] = useState(state.billingInformation.attributes);

  const formSendSuccess = () => {
    swal({
      title: "Billing Information Updated!",
      text: "",
      html: true,
      type: "success",
      showCancelButton: false,
      confirmButtonText: "Close",
      closeOnConfirm: true,
    });
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    actions.saveBillingInformation(dispatch, state.enterpriseId, values, () => {
      setLoader(false);
      closeForm();
      formSendSuccess();
    });
  };

  useEffect(() => {
    countryActions.load(countryDispatch);
  }, []);

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <TextField
        name="name"
        label={
          <>
            <span>Name</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <TextField
        name="email"
        type="email"
        label={
          <>
            <span>E-Mail</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <SelectFieldV2
        name="country"
        placeholder={
          countryState.countries == null ? "Load Countries" : "Select a Country"
        }
        isMulti={false}
        options={countryState.countries || []}
        label={
          <>
            <span>Country</span>
          </>
        }
      />

      <TextField
        name="city"
        label={
          <>
            <span>City</span>
          </>
        }
      />

      <TextField
        name="address_line1"
        label={
          <>
            <span>Address Line 1</span>
          </>
        }
      />

      <TextField
        name="address_line2"
        label={
          <>
            <span>Address Line 2</span>
          </>
        }
      />

      <TextField
        name="postal_code"
        label={
          <>
            <span>Postal Code</span>
          </>
        }
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={closeForm}
        />
        <SubmitButton
          title={loader ? "Please, wait ..." : "Save"}
          className={`btn width-120 btn-primary submit-button mr5 ml5 ${
            loader ? "not-possible-click" : ""
          }`}
        />
      </div>
    </BaseForm>
  );
}
